.grid { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.segs { display: flex; align-items: center; gap: 8px; }
.tiles { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; }
.tile { padding: 12px 14px; border-radius: 14px; background: var(--card); box-shadow: var(--sh); min-width: 0; }
.tile > span { display: block; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tile > b { display: block; margin-top: 2px; font-size: 22px; font-weight: var(--fw-label); white-space: nowrap; }

.panel { display: flex; flex-direction: column; gap: 12px; padding: 16px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); min-width: 0; font-size: 13px; }
.hd { display: flex; align-items: center; gap: 10px; min-height: 30px; }
.hd h2 { margin: 0; font-size: 15px; font-weight: var(--fw-title); white-space: nowrap; }
.hd span { flex: 1; min-width: 0; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.hd button { height: 30px; padding: 0 10px; border: 0; border-radius: 9px; background: var(--pri-bg); color: var(--link); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }

.bars { display: grid; gap: 0 28px; }
.brow { display: flex; align-items: center; gap: 12px; min-height: 40px; min-width: 0; }
.brow.top { border-top: 1px solid var(--line); }
.bl { width: 34%; flex: none; min-width: 0; }
.bl b { display: block; font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.bl small { display: block; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.track { flex: 1; min-width: 0; height: 10px; border-radius: 4px; background: var(--skel); }
.fill { height: 10px; border-radius: 4px; }
.bv { width: 72px; flex: none; text-align: right; font-weight: var(--fw-label); white-space: nowrap; }
.bv small { display: block; font-size: 12px; font-weight: 500; color: var(--lb); }

.tbl { width: 100%; table-layout: fixed; border-collapse: collapse; }
.tbl th { height: 34px; padding: 0 10px; text-align: left; font-size: 12px; font-weight: var(--fw-label); color: var(--lb); border-bottom: 1px solid var(--line); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tbl td { height: 49px; padding: 0 10px; border-bottom: 1px solid var(--line); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tbl .r { text-align: right; }
.tbl .nm { font-weight: var(--fw-label); color: var(--link); }
.tbl .seat { color: var(--tx2); }
.tbl .none { color: var(--lb); }
.tbl .sc { font-weight: var(--fw-label); }
.chipG { padding: 2px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); }
.list { display: flex; flex-direction: column; }
.lrow { display: flex; align-items: center; gap: 10px; min-height: 40px; }
.lrow + .lrow { border-top: 1px solid var(--line); }
.lrow > span:first-child { color: var(--tx2); white-space: nowrap; }
.lrow > span:nth-child(2) { flex: 1; min-width: 0; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lrow > b { font-weight: var(--fw-label); white-space: nowrap; }
